/* Shared progressive enhancement; native viewers own loading, selection and commerce. */
(() => {
  if (window.MobilegsViewerCue) return;
  const create = ({ root, native, stage, container = stage, state, activate }) => {
    if (!native || !stage || !container) return null;
    const cue = document.createElement('button');
    cue.type = 'button'; cue.className = 'sequence-cue';
    const icon = document.createElement('span'); icon.className = 'sequence-cue__icon'; icon.setAttribute('aria-hidden', 'true');
    const svg = native.querySelector('svg'); if (svg) icon.append(svg.cloneNode(true));
    const label = document.createElement('span'); label.className = 'sequence-cue__label'; label.setAttribute('aria-live', 'polite');
    cue.append(icon, label); container.append(cue); root.classList.add('mg-viewer-sequence');
    let phase = '', timer;
    const dismiss = () => cue.classList.add('is-dismissed');
    const sync = () => {
      const next = state(phase);
      if (cue.hidden !== (next.visible === false)) cue.hidden = next.visible === false;
      if (phase === next.phase) return;
      phase = next.phase; clearTimeout(timer); cue.dataset.phase = phase; cue.classList.remove('is-dismissed');
      label.textContent = { photo: 'View in 3D', loading: 'Loading…', ready: 'Drag to rotate', retry: 'Retry 3D' }[phase];
      cue.disabled = phase === 'loading' || phase === 'ready'; cue.tabIndex = phase === 'ready' ? -1 : 0;
      cue.setAttribute('aria-busy', String(phase === 'loading'));
      if (phase === 'ready') timer = setTimeout(dismiss, 3000);
    };
    const click = event => { if (!cue.hidden) activate(event.detail === 0); };
    const interact = event => { if (phase === 'ready' && event.composedPath().some(n => n.localName === 'model-viewer')) dismiss(); };
    cue.addEventListener('click', click);
    ['pointerdown', 'wheel', 'keydown'].forEach(type => stage.addEventListener(type, interact, { passive: true }));
    const observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-busy'], childList: true, characterData: true, subtree: true });
    sync();
    return {
      sync,
      rearm() { if (state(phase).phase === 'ready') { phase = ''; sync(); } },
      focus() { sync(); if (!cue.hidden && !cue.disabled) cue.focus({ preventScroll: true }); },
      destroy() {
        observer.disconnect(); clearTimeout(timer); cue.removeEventListener('click', click);
        ['pointerdown', 'wheel', 'keydown'].forEach(type => stage.removeEventListener(type, interact));
        cue.remove(); root.classList.remove('mg-viewer-sequence');
      }
    };
  };
  window.MobilegsViewerCue = {
    pdp(mount) {
      return create({ root: mount, native: mount.activateButton, stage: mount.stage, activate: focus => mount.activate(focus), state: () => ({
        visible: mount.dataset.universalDesigns === 'true' ? (mount.frame?.closest('[data-media-id]') || mount.slide)?.dataset.mediaId === mount.variantMediaId() : !!mount.posterSlide && (mount.frame?.closest('[data-media-id]') || mount.slide) === mount.posterSlide,
        phase: mount.activateButton.getAttribute('aria-busy') === 'true' || mount.classList.contains('is-pdp-swapping') ? 'loading' : mount.active ? 'ready' : mount.activateLabel.textContent.includes('Retry') ? 'retry' : 'photo'
      }) });
    },
    studio(root, activate) {
      // Position against the model region, excluding the desktop selector dock.
      // Keep interaction listeners on the full stage for fullscreen/reparenting.
      return create({ root, native: root.querySelector('[data-style-activate]'), stage: root.querySelector('[data-style-stage]'), container: root.querySelector('[data-style-viewer-region]'), activate, state: phase => ({
        phase: root.classList.contains('is-loading-3d') ? 'loading' : root.classList.contains('is-3d') ? 'ready' : phase === 'loading' || phase === 'retry' ? 'retry' : 'photo'
      }) });
    }
  };
})();
